import * as React from 'react';

import { Icon, Popup } from 'semantic-ui-react';

import ErrorCatch from '../../containers/ErrorBoundary/ErrorCatch';
import { localeData } from '../../locales/data';
import { addModifiers } from '../../shared/helpers';

import './ToolTip.scss';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface ToolTipContentProps {
  label?: string;
  isLabelFormatted?: boolean;
  isInfoFormatted?: boolean;
  tooltipInfo: string | JSX.Element | JSX.Element[] | React.ReactNode;
  url?: string;
  modifiers: string[];
}

const ToolTipContent = ({
  label,
  tooltipInfo,
  isLabelFormatted = false,
  isInfoFormatted = false,
  url,
  modifiers = [],
}: ToolTipContentProps) => {
  const fullheaderModifier = url ? [] : ['full'];
  try {
    return (
      <div className={addModifiers('tooltip-wbs__content', modifiers)} onClick={e => e.stopPropagation()}>
        {label && (
          <div className={addModifiers('tooltip-wbs__content-header', fullheaderModifier)}>
            {isLabelFormatted ? label : <FormattedMessageHelper tagName="span" id={label} defaultMessage={localeData.en[label]} />}:
          </div>
        )}
        <div className="tooltip-wbs__content-link">
          {url && (
            <a href={url} target="blank">
              <Icon name="external" />
              <FormattedMessageHelper
                tagName="span"
                id="editorSettingsFormElement.learnMore"
                defaultMessage={localeData.en['editorSettingsFormElement.learnMore']}
              />
            </a>
          )}
        </div>
        <div className="tooltip-wbs__content-description">
          {isInfoFormatted ? (
            tooltipInfo
          ) : (
            <FormattedMessageHelper tagName="span" id={tooltipInfo as string} defaultMessage={localeData.en[tooltipInfo as string]} />
          )}
        </div>
      </div>
    );
  } catch (error) {
    return <ErrorCatch error={error} />;
  }
};

interface ToolTipProps {
  btnModifiers?: string[];
  modifiers?: string[];
  contentModifiers?: string[];
  url?: string;
  label?: string;
  tooltipInfo: string | JSX.Element | JSX.Element[] | React.ReactNode;
  isTooltipInfoFormatted?: boolean;
  isTooltipLabelFormatted?: boolean;
  hasError?: boolean;
  on?: 'click' | 'hover';
}

export class ToolTip extends React.Component<ToolTipProps> {
  state = {
    popupIsOpen: false,
  };

  handleOpen = () => {
    this.setState({ popupIsOpen: true });
  };

  handleClose = () => {
    this.setState({ popupIsOpen: false });
  };

  render() {
    const {
      btnModifiers = [],
      contentModifiers = [],
      modifiers = [],
      tooltipInfo,
      isTooltipInfoFormatted,
      label,
      isTooltipLabelFormatted,
      url,
      hasError,
      on = 'click',
    } = this.props;

    const pulsateModifiers = this.state.popupIsOpen ? ['animate'] : [];

    return (
      <Popup
        trigger={
          hasError ? (
            <div onClick={this.handleOpen} className={addModifiers('pulsate', pulsateModifiers)}>
              <div className={addModifiers('tooltip-wbs__btn', btnModifiers)} />
            </div>
          ) : (
            <div onClick={this.handleOpen} className={addModifiers('tooltip-wbs__btn', btnModifiers)} />
          )
        }
        content={
          <ToolTipContent
            label={label}
            isLabelFormatted={isTooltipLabelFormatted}
            tooltipInfo={tooltipInfo}
            url={url}
            modifiers={contentModifiers}
            isInfoFormatted={isTooltipInfoFormatted}
          />
        }
        on={on}
        open={this.state.popupIsOpen}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        basic={true}
        className={addModifiers('tooltip-wbs', modifiers)}
        hoverable
      />
    );
  }
}
